import React, { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ForbiddenError, NotFound as NotFoundError } from '@townsquare/error-state/classes';

import { ErrorScreen, ForbiddenScreen, NotFoundScreen } from './scenarios';

type BootstrapErrorBoundaryProps = {
  onError?: () => void;
};

export const BootstrapErrorBoundary = (props: React.PropsWithChildren<BootstrapErrorBoundaryProps>) => {
  const { children, onError } = props;

  const handleOnError = useCallback(() => {
    onError?.();
  }, [onError]);

  return (
    <ErrorBoundary
      onError={handleOnError}
      fallbackRender={({ error }) => {
        if (error instanceof ForbiddenError) {
          return <ForbiddenScreen />;
        }

        if (error instanceof NotFoundError) {
          return <NotFoundScreen />;
        }

        return <ErrorScreen />;
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
